import { ContractStageType } from '../../../../models/Entities/Contracts/ContractStageType';
import { ErrorType } from '../../../../models/HttpError';
import * as ContractStageTypeStore from '../../../../redux/middleware/ContractStageType.Middleware';
import { AppState } from '../../../../redux/reducers';

interface IProps {
    isOpen: boolean;
    openPanel: () => void;
    dismissPanel: () => void;
    StageTypeId?: number;
}

interface ConnectedProps {
    isSaving: boolean;
    isSavedSuccessfully: boolean;
    failOnSaving: boolean;
    error: ErrorType | undefined;
    StageType?: ContractStageType;
}

interface DispatchProps {
    GetContractStageTypeById: typeof ContractStageTypeStore.actionCreators.GetContractStageTypeById;
    CreateContractStageType: typeof ContractStageTypeStore.actionCreators.CreateContractStageType;
    UpdateContractStageType: typeof ContractStageTypeStore.actionCreators.UpdateContractStageType;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const stageType = (state.ContractStageType?.list || []).find((st: any) => st.id === ownProps.StageTypeId);
    return {
        isSaving: state.ContractStageType?.isAddingNewOne || state.ContractStageType?.isUpdatingOne || false,
        isSavedSuccessfully: state.ContractStageType?.successAddingNewOne || state.ContractStageType?.successUpdatingOne || false,
        failOnSaving: state.ContractStageType?.failOnAddingNewOne || state.ContractStageType?.failOnUpdatingOne || false,
        error: state.ContractStageType?.error,
        StageType: stageType,
    };
};

export const mapDispatchToProps = {
    ...ContractStageTypeStore.actionCreators,
};
